<template>
  <div class="dashboard">
    <div>
      <v-skeleton-loader type="table-tbody" v-if="loading"/>
      <div class="inner" v-if="!loading">
        <div class="interior-header">
          <h2>Details</h2>
          <download-button data-testid="download-btn" @click="downloadTable" />
        </div>
        <table id="insurer-ratings" v-tablesort class="dense mt-4">
          <thead>
          <tr>
            <td class="sorted ascending">Issuing Company Name</td>
            <td class="dataindex">AM Best Rating</td>
            <td>Size Category</td>
            <td class="nosort">Rating Effective Date</td>
            <td class="nosort">Previous Rating</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, index) in data" :key="index" data-test="row">
            <td>{{ row.issuingCompanyName }}</td>
            <td :data-index="row.indexPos">{{ row.rating }}</td>
            <td>{{ row.financialSizeCategory }}</td>
            <td>{{ formatDate(row.ratingEffectiveDate) }}</td>
            <td>{{ row.previousRating }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { carrierService } from '@/services/api';
import { DownloadTableToCSV } from '@/utilities/Download';
import DownloadButton from '@/components/v2/DownloadButton.vue';
import { DateTime } from 'luxon';

export default {
  name: 'CarrierInsurerFinancials',
  components: { DownloadButton },
  data: () => ({
    loading: true,
    data: [],
  }),
  methods: {
    async refreshData() {
      this.loading = true;
      this.data = await carrierService.financialsById(this.$route.params.id);
      this.loading = false;
    },
    async downloadTable() {
      const { name } = await carrierService.findById(this.$route.params.id);
      DownloadTableToCSV('#insurer-ratings', name);
    },
    formatDate(date) {
      if (!date) return '';
      return DateTime.fromISO(date, { zone: 'utc' }).toLocaleString()
    },
  },
  async created() {
    return this.refreshData();
  }
};
</script>

<style scoped>
.interior-header {
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 1rem;
  align-content: center;
  align-items: center;
  justify-content: left;
}
</style>
